




























import PreselectTemplateCard from "@/components/partner/PreselectTemplateCard.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { PreselectTemplateKeysEnum } from "@/lib/enum/preselect-template-keys.enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IReport } from "@/models/report.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";

@Component({
  components: { PreselectTemplateCard, ConfirmActionDialog }
})
export default class ClaimSettlementSendDialog extends mixins(PermissionMixin, RulesMixin) implements IDialog {
  @Prop({ default: false }) value!: boolean;
  @Prop() report?: IReport;

  @Ref("templateCard")
  templateCard!: PreselectTemplateCard;

  templateKey = PreselectTemplateKeysEnum.CLAIM_SETTLEMENT_MAIL;

  dialog: boolean = this.value;

  @Watch("value")
  onValueChange(val: boolean) {
    this.dialog = val;
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    this.$emit("input", val);
  }

  get refs() {
    if (!this.report?.id) {
      return [];
    }
    return [{ refId: this.report.id, refType: ResourceEnum.REPORT }];
  }

  get partner() {
    return PartnerModule.partner;
  }

  get vehicle() {
    return this.report?.vehicle;
  }

  get context() {
    const firstSharedContent = this.report?.companyCompany?.sharedContent?.[0];
    return {
      partner: this.partner,
      report: this.report,
      vehicle: this.vehicle,
      url: {
        sharing: firstSharedContent?.url ?? ""
      }
    };
  }

  get toMail() {
    return this.report?.companyCompany?.contact?.email ? [this.report.companyCompany.contact.email] : [];
  }

  get myUserId() {
    return UserModule.userId;
  }

  async sendMail() {
    try {
      await this.templateCard?.send();
      this.close();
    } catch (error) {
      handleError(error);
    }
  }

  open() {
    this.dialog = true;
  }

  close() {
    this.dialog = false;
  }
}
